(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-ceramel-studie"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.csReady)return;root.dataset.csReady='true';const config=JSON.parse(root.querySelector('[data-cs-config]').textContent);
const metrics=config.metrics;
root.querySelectorAll('[data-metric]').forEach(button=>button.addEventListener('click',()=>{const m=metrics[button.dataset.metric];root.querySelectorAll('[data-metric]').forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))});for(const [id,value] of Object.entries({'chart-tool':m.tool,'chart-title':m.title,'chart-description':m.description,'before-value':m.labels[0],'after-value':m.labels[1],'chart-note':m.note})){root.querySelector('[data-cs-role="'+id+'"]').textContent=value}const max=Math.max(m.before,m.after)/.8;root.querySelector('[data-cs-role="before-bar"]').style.width=(m.before/max*100)+'%';root.querySelector('[data-cs-role="after-bar"]').style.width=(m.after/max*100)+'%';root.querySelector('[data-cs-role="chart-count"]').innerHTML='<b>'+m.count+' '+config.of_twenty+'</b><br>'+config.improvement;root.querySelector('[data-cs-role="chart-source"]').href=config.report.split('#')[0]+'#page=2';}));
const photos={redness:{src:config.redness,alt:config.redness_alt,title:config.redness_title,description:config.redness_description},texture:{src:config.texture,alt:config.texture_alt,title:config.texture_title,description:config.texture_description}};
root.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{const p=photos[button.dataset.image];root.querySelectorAll('[data-image]').forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))});const img=root.querySelector('[data-cs-role="study-image"]');img.src=p.src;img.alt=p.alt;img.title=p.title;root.querySelector('[data-cs-role="image-description"]').textContent=p.description;}));
}document.querySelectorAll('.bh-ceramel').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.bh-ceramel').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-knowledge-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bh-knowledge-hub')) {
    customElements.define('bh-knowledge-hub', class extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('[data-topic]'));
        this.cards = Array.from(this.querySelectorAll('[data-article-topics]'));
        this.count = this.querySelector('[data-count-template]');
        this.onHashChange = () => this.applyHash();
        this.onNavigationClick = (event) => {
          const link = event.target.closest('a[href]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = new URL(link.href, location.href);
          if (target.origin !== location.origin || target.pathname !== location.pathname) return;
          if (!this.links.some(topicLink => topicLink.getAttribute('href') === target.hash)) return;
          if (document.body.classList.contains('reveal-mobile-nav')) {
            document.querySelector('.navigation__mobile-header .mobile-nav-toggle')?.click();
          }
        };
        this.onClick = (event) => {
          const link = event.target.closest('[data-topic]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const hash = link.getAttribute('href');
          history.pushState(null, '', hash);
          this.applyHash();
        };
        this.addEventListener('click', this.onClick);
        document.addEventListener('click', this.onNavigationClick);
        window.addEventListener('hashchange', this.onHashChange);
        window.addEventListener('popstate', this.onHashChange);
        this.applyHash();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('click', this.onNavigationClick);
        window.removeEventListener('hashchange', this.onHashChange);
        window.removeEventListener('popstate', this.onHashChange);
      }
      applyHash() {
        const selected = this.links.find(link => link.getAttribute('href') === location.hash) || this.links[0];
        const topic = selected.dataset.topic;
        let visible = 0;
        this.cards.forEach(card => {
          const show = topic === 'all' || card.dataset.articleTopics.split(' ').includes(topic);
          card.hidden = !show;
          if (show) visible += 1;
        });
        this.links.forEach(link => {
          if (link === selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.count.textContent = visible === 1 ? this.count.dataset.countSingular : this.count.dataset.countTemplate.replace('__COUNT__', visible);
        this.querySelector('[data-empty]').hidden = visible > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
